import cn from 'classnames'

import { Header, HeaderContent } from 'app/common/layouts/RowLayout'
import IconExcel from 'app/common/icons/IconExcel'
import { GenerateFile } from 'app/common/ui-components/progress-indicator'
import HistoryModal from 'app/common/ui-components/history-modal'
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
import useGenerateFileHistory, { reportTypes } from 'app/components/common/reports/history/useGenerateFileHistory'
import useGenerateFileRequests from 'app/components/common/reports/history/useGenerateFileRequests'

import styles from './OOPResultHeader.scss'


type Props = {
  reportId: number
  reportFileName: string
  className?: string
}

export const OOPResultHeader = ({ reportId, reportFileName, className }: Props) => {
  const generateFileRequests = useGenerateFileRequests(reportId, reportFileName)
  const historyModalProps = useGenerateFileHistory(reportTypes.REPORT_ORDERS_PURCHASES)

  return (
    <HeaderContent className={cn(styles.root, className)}>
      <Header>{'Продукция из заявок'}</Header>

      <GenerateFile
        labelClassName={styles.downloadLabel}
        label="Скачать как"
        generateAndDownloadPrompt="Сгенерировать и скачать в формате «документ Excel»"
        downloadPrompt="Скачать в формате «документ Excel»"
        {...generateFileRequests}
      >
        <IconExcel className={styles.downloadIcon} />
      </GenerateFile>

      <HistoryModal {...historyModalProps}>
        {toggle => (
          <PlainButtonAsLink onClick={toggle} className={styles.historyButton}>
            {'История загрузок'}
          </PlainButtonAsLink>
        )}
      </HistoryModal>
    </HeaderContent>)
}
